import React from 'react';
import classNames from 'classnames/bind';
import logo from '../../assets/images/logo-1.png'
import styles from './LoadComponent.module.css'

const cx = classNames.bind(styles)
const LoadComponent = () => {
    return (
        <div className={cx("container")}>
            <div className={cx("content")}>
                <img src={logo} width={'100%'} alt='Logo'/>
            </div>
        </div>
    );
};

export default LoadComponent;